/* eslint-disable no-unused-vars */
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  OppHeader,
  OppTraining,
  OppDescription,
  OppRequirements,
  OppCommitment,
} from 'features/opportunity/components';
import { Error, LocationBadge } from 'components';
import { LoadingSpinner } from 'components/elements';
import { normaliseData } from 'features/opportunity/helpers';
import { useOpportunity } from 'features/opportunity/api';
import { useApplications, useAssignments } from 'features/dashboard/api';
import getButtonProps from 'features/opportunity/helpers/getStatus';
import * as S from './styles';

function Opportunity() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: opportunityData, isLoading, isError, error, refetch } = useOpportunity(id);
  const { data: applicationsData } = useApplications();
  const { data: assignmentsData } = useAssignments();

  const buttonProps = React.useMemo(
    () => getButtonProps(applicationsData, assignmentsData, opportunityData, id),
    [applicationsData, assignmentsData, opportunityData, id],
  );

  function redirectToApplication() {
    navigate(`/opportunities/${id}/application`);
  }

  function redirectToOpportunities() {
    navigate(`/opportunities`);
  }

  const errorProps = () => {
    if (error?.response?.status === 404) {
      return {
        mainText: 'Sorry, we couldn not find this opportunity.',
        buttonLabel: 'See more opportunities',
        handleClick: () => redirectToOpportunities(),
      };
    }

    return {
      mainText: 'Sorry, something went wrong',
      buttonLabel: 'Load page again',
      handleClick: () => refetch(),
    };
  };

  const KeysToComponentMap = {
    city: LocationBadge,
    trainingRequired: OppTraining,
    description: OppDescription,
    requirements: OppRequirements,
    commitment: OppCommitment,
  };

  function renderComponent(obj) {
    return (
      typeof KeysToComponentMap[obj.id] !== 'undefined' &&
      React.createElement(KeysToComponentMap[obj.id], { key: obj.id, data: obj.data })
    );
  }

  if (isLoading) return <LoadingSpinner />;

  if (isError) return <Error iconName="sad_face" label="Error loading page" {...errorProps()} />;

  return (
    <>
      {opportunityData.name && (
        <S.Header>
          <OppHeader
            name={opportunityData?.name}
            handleApplyNow={() => redirectToApplication()}
            buttonProps={buttonProps}
          />
        </S.Header>
      )}
      <S.Body>
        <S.InnerBodyWrapper>
          {normaliseData(opportunityData).map((datum) => renderComponent(datum))}
        </S.InnerBodyWrapper>
      </S.Body>
    </>
  );
}

export default Opportunity;
